// extracted by mini-css-extract-plugin
export default {"users_setting":"UsersSetting_users_setting__XmIVe","header_buttons":"UsersSetting_header_buttons__lNpuv"};